import React, {useEffect, useState} from "react";
import './_filter-content.scss';
import FormatFilterTile from "../../atoms/format-filter-tile/format-filter-tile";
import {clubFinderSearchBarSliceActions} from "../../../../store/slices/clubFinderSearchBarSlice";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../../store/configureStore";
import GenderFilterComponent from "../../molecules/gender-filter-component/gender-filter-component";
import InclusionFilterComponent from "../../molecules/inclusion-filter-component/inclusion-filter-component";
import DaysFilterComponent from "../../molecules/days-filter-component/days-filter-component";
import {Config, TenantAppVersionConfig, ignoredInclusions} from "../../../../constants/Config";
import {getSelectedFilterCount} from "../../../../utilities/getSelectedFilterCount";
import {InclusionType} from "../../../../types/ApiTypeDefinition/singleClubFinderResultTypes";

const baseClass = 'filter-content-container';

interface PropTypes {
  genderFilterOptions: any;
  inclusionFilterOptions: any;
  daysFilterOptions: any;
  formatFilterOptions: any
  learnMoreLink?: any
  handleBackAction?: any
  handleApplyAction?: any
  tenant: string
}

const FilterContent = (props: PropTypes): JSX.Element => {
  const dispatch = useDispatch();
  const tenant = useSelector((state: RootState) => state.widgetConfigurationSettings.tenant);
  const [selectedFormatObject, setSelectedFormatObject] = useState<[]|string[]>([]);
  const [selectedFormatTitles, setSelectedFormatTitles] = useState([]);
  const savedFormatFilter: any = useSelector((state: RootState) => state.clubFinderSearchBarStore.selectedFormat);
  const savedFormatFilterName: any = useSelector((state: RootState) => state.clubFinderSearchBarStore.selectedFormatFilterName);
  const activeSearchFilter: any = useSelector((state: RootState) => state.clubFinderSearchBarStore.activeSearchFilterMobile)
  const applyClickedCounter = useSelector((state: RootState) => state.clubFinderSearchBarStore.applyClickedCounter);
  const selectedMultiGenderFilters = useSelector((state: RootState) => state.clubFinderSearchBarStore.selectedMultiGenderFilters);
  const selectedInclusionFilter = useSelector((state: RootState) => state.clubFinderSearchBarStore.selectedInclusionFilters);
  const selectedDaysFilter = useSelector((state: RootState) => state.clubFinderSearchBarStore.selectedDayFilters);
  const [totalSelectedFilterCount, setTotalSelectedFilterCount] = useState(0);
  const breakpointClass = useSelector((state: RootState) => state.widgetConfigurationSettings.breakpointClass);
  const allFormats  = useSelector((state: RootState) => state.widgetConfigurationSettings.formats);

  useEffect(() => {
    if (savedFormatFilter && savedFormatFilter?.length > 0) {
      setSelectedFormatObject(savedFormatFilter);
      setSelectedFormatTitles(savedFormatFilterName);
    }
  }, [savedFormatFilter, activeSearchFilter, savedFormatFilterName])

  useEffect(() => {
    dispatch(clubFinderSearchBarSliceActions.setSavedFormatFilter({selectedFormatObject, selectedFormatTitles}))
  }, [selectedFormatObject, selectedFormatTitles])

  const setSelectedFormat = (selectedFormat: any, formatTitle: any) => {
    const selectedFormatTitlesObject: any = [...selectedFormatTitles];
    if (!selectedFormatTitlesObject.includes(formatTitle)) {
      selectedFormatTitlesObject.push(formatTitle)
    } else {
      const index = selectedFormatTitlesObject.indexOf(formatTitle);
      if (index !== -1) {
        selectedFormatTitlesObject.splice(index, 1);
      }
    }
    // @ts-ignore
    setSelectedFormatTitles([...selectedFormatTitlesObject]);
    const selectedFormats = getUniquePlayHqFormats(allFormats, selectedFormatTitlesObject);
    setSelectedFormatObject(selectedFormats)
  }

  const getUniquePlayHqFormats = (formats: any[], selectedFormatFilterName: string[]): []|string[] => {
    let selectedFormats = formats.filter(format => selectedFormatFilterName.includes(format.name));
    let uniquePlayHqFormats: string[] = []

    selectedFormats.forEach(format => {
      format.playHqFormats.forEach((playHqFormat: string) => {
        uniquePlayHqFormats.push(playHqFormat);
      });
    });

    return uniquePlayHqFormats;
  }

  const handleClearAction = () => {
    dispatch(clubFinderSearchBarSliceActions.setSavedMultiGenderFilter(null));
    dispatch(clubFinderSearchBarSliceActions.setSavedFormatFilter({
      selectedFormatObject: null,
      selectedFormatTitles: null
    }));
    dispatch(clubFinderSearchBarSliceActions.setSavedInclusionFilter(null));
    dispatch(clubFinderSearchBarSliceActions.setSavedDayFilter(null));
    const currentURL = new URL(window.location.href);
    const searchParams = new URLSearchParams(currentURL.search);
    if (searchParams.has(Config.filterSearchParams[props.tenant as keyof typeof Config.filterSearchParams].genders)) {
      searchParams.delete(Config.filterSearchParams[props.tenant as keyof typeof Config.filterSearchParams].genders);
    }
    if (searchParams.has(Config.filterSearchParams[props.tenant as keyof typeof Config.filterSearchParams].formats)) {
      searchParams.delete(Config.filterSearchParams[props.tenant as keyof typeof Config.filterSearchParams].formats);
    }
    if (searchParams.has(Config.filterSearchParams[props.tenant as keyof typeof Config.filterSearchParams].inclusions)) {
      searchParams.delete(Config.filterSearchParams[props.tenant as keyof typeof Config.filterSearchParams].inclusions);
    }
    if (searchParams.has(Config.filterSearchParams[props.tenant as keyof typeof Config.filterSearchParams].days)) {
      searchParams.delete(Config.filterSearchParams[props.tenant as keyof typeof Config.filterSearchParams].days);
    }
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.replaceState({}, document.title, newUrl);

    dispatch(clubFinderSearchBarSliceActions.setApplyClickedCount(applyClickedCounter + 1));
  }

  const formatFilterTiles = props.formatFilterOptions.map((formatOption: any, index: number) =>
    <FormatFilterTile formatLogo={formatOption.logo} formatLabel={formatOption.name}
                      formatDescription={formatOption.description} formatTags={formatOption.playHqFormats}
                      setSelectedFormat={(selectedFormats: any, formatTitle: any) => setSelectedFormat(selectedFormats, formatTitle)}
                      formatTagsDisplay={formatOption.tags}
                      selectedFormatFilterName={savedFormatFilterName}
                      selectedFormat={savedFormatFilter} key={index}/>
  );

  useEffect(() => {
    if (savedFormatFilter == null) {
      setSelectedFormatObject([]);
      setSelectedFormatTitles([]);
    }
  }, [savedFormatFilter])


  useEffect(() => {
    const totalSelectedFilters = getSelectedFilterCount(savedFormatFilterName, selectedMultiGenderFilters, selectedInclusionFilter, selectedDaysFilter);
    setTotalSelectedFilterCount(totalSelectedFilters);
  }, [savedFormatFilterName, selectedMultiGenderFilters, selectedInclusionFilter, selectedDaysFilter]);

  const applyButtonClickedHandler = () => {
    props.handleApplyAction();
  }

  return (
    <div className={`${baseClass} ${props.tenant} ${breakpointClass}`}
         style={
           {
             '--secondaryFont': props.tenant ? TenantAppVersionConfig[props.tenant].fonts.fontSecondary : '',
             '--primaryFont': props.tenant ? TenantAppVersionConfig[props.tenant].fonts.fontPrimary : '',
             '--brandPrimaryColour': props.tenant ? TenantAppVersionConfig[props.tenant].colours.brandPrimary : ''
           } as React.CSSProperties
         }>

      <div className={`${baseClass}--header`}>
        <div className={`${baseClass}--back-button`} onClick={props.handleBackAction}>
          <img src={props.tenant? TenantAppVersionConfig[props.tenant].icons.leftArrow : ''} alt={'left-arrow'}/>
        </div>
        <div className={`${baseClass}--button-wrapper`}>
          <button className={`${baseClass}--button clear`} onClick={handleClearAction}>Clear</button>
          <button className={`${baseClass}--button apply ${totalSelectedFilterCount > 0 ? 'enabled' : 'disabled'} `}
                  onClick={totalSelectedFilterCount > 0 ? applyButtonClickedHandler : undefined}>Apply
          </button>
        </div>
      </div>

      <div className={`${baseClass}--format-filter-wrapper`}>
        {formatFilterTiles}

        {props.learnMoreLink && (
          <div className={'learn-more-format-text'}>Not sure which format is right for you? <a
            className={'learn-more-link'} href={props.learnMoreLink}>Learn more </a></div>
        )}
      </div>

      {props.genderFilterOptions && props.genderFilterOptions.length > 0 && (
        <GenderFilterComponent genderFilterOptions={props.genderFilterOptions}/>
      )}

      {props.inclusionFilterOptions && props.inclusionFilterOptions.length > 0 && (
        <InclusionFilterComponent
          inclusionFilterOptions={(props.inclusionFilterOptions && props.inclusionFilterOptions.length > 0) ?
            props.inclusionFilterOptions.filter((item: InclusionType) => !ignoredInclusions[tenant].includes(item.inclusionPlayHQValue)) : null}/>
      )}

      {props.daysFilterOptions && props.daysFilterOptions.length > 0 && (
        <DaysFilterComponent daysFilterOptions={props.daysFilterOptions}/>
      )}
    </div>
  )
}

export default FilterContent;
